import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16px",
  height: "16px",
  viewBox: "0 0 16 16",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_2 = {
  id: "页面-1",
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_3 = ["stroke"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("g", {
  id: "编组",
  transform: "translate(947.000000, 165.000000) rotate(-90.000000) translate(-947.000000, -165.000000) translate(939.000000, 157.000000)"
}, [
  /*#__PURE__*/_createElementVNode("polyline", {
    id: "路径-5",
    points: "4 6 8 10 12 6"
  })
], -1)
const _hoisted_5 = [
  _hoisted_4
]


export default /*#__PURE__*/_defineComponent({
  __name: 'IconRightArrow',
  props: {
  color: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("g", {
        id: "个人中心",
        transform: "translate(-939.000000, -157.000000)",
        stroke: __props.color
      }, _hoisted_5, 8, _hoisted_3)
    ])
  ]))
}
}

})